import React from "react";
import Layout from "./layout/layout";
import './App.css'

function App() {
  return <Layout />;
}

export default App;
